import { useNavigate } from "react-router-dom";

function useDetailsAction(): any {

  const navigate = useNavigate();

  const detailsFunction = (id: any) => {
      navigate(`/panel/1/1/treatment-session-types/${id}`);
  };

  /** END EDIT FORM ACTION */

  return {
    detailsFunction,
  };
}

export default useDetailsAction;
